import { createTheme, Theme } from "@mui/material"
import { generalConfigs, themeConfigsLight } from "utils/customizedTheme"

export const useCustomizedTheme = (): {theme :Theme} => {

  const { palette: paletteLight, components: componentsLight } = themeConfigsLight
  const { typography: typographyGeneral, components: componentsGeneral } = generalConfigs

  const theme = createTheme({
    palette: {
      ...paletteLight,
    },
    components: {
      ...componentsLight,
      ...componentsGeneral,
    },
    typography: {
      ...typographyGeneral,
    }
  })

  return {theme}
}
